import React from 'react';
import { Dialog, DialogContent, IconButton, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function FooterModalPopup(props) {
    return (
        <Dialog open={props.open} onBackdropClick={props.onDialogClose} onClose={props.onDialogClose} scroll="body" maxWidth='md'>
            <DialogContent className={`${props.isInsideModal ? 'grey-h5' : ''} product-info-dialog-content-footer`}>
                <IconButton
                    className="product-info-close-button"
                    aria-label="close"
                    onClick={props.onDialogClose}
                    size="large">
                    <CloseIcon />
                </IconButton>
                {props.component}
            </DialogContent>
        </Dialog>
    );
}
